/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Error_Slug1Inputs */

const vi_cmspost_error_slug1 = /** @type {(inputs: Cmspost_Error_Slug1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đường dẫn chỉ gồm chữ thường không dấu, số và dấu gạch ngang (vd che-tan-cuong).`)
};

/**

* @param {Cmspost_Error_Slug1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_error_slug1 = /** @type {((inputs?: Cmspost_Error_Slug1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Error_Slug1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_error_slug1(inputs)
});
export { cmspost_error_slug1 as "cmsPost_error_slug" }